export class CustomActionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomAction() {
    return this.#http.get('/customAction');
  }
}
